import React, { useState, useEffect } from 'react';

import utils from '../../../lib/utils';
import './index.scss';

const csroles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];

const StaffInfo = ({ saveBusinessName, auth, business }) => {
  const { clientUser: info, info: business_info, updatingBusinessName } = business;
  const business_name = utils.getCookie('studio_name') || auth?.studio_name;
  const [businessName, setBusinessName] = useState(business_name);

  // Update local state if prop changes
  useEffect(() => {
    setBusinessName(business_name);
  }, [business_name]);

  const handleSave = () => {
    saveBusinessName(businessName);
  };

  return (
    <div className="basicinfo">
      <div className="title">Account Info</div>
      <div className="name">
        {info.firstName} {info.lastName}
      </div>
      <div className="other-info">{info.email}</div>
      <div className="other-info">{info.phone}</div>
      {csroles.includes(auth.role) && <>
        <div className="input">
          <label className="label">Business Name</label>
          <input type="text" defaultValue={businessName} onChange={(e) => setBusinessName(e.target.value)} maxLength="100" />
        </div>
        <div className="actions">
          <button className="btn btn--primary btn--lg" onClick={handleSave} disabled={updatingBusinessName || businessName.length < 1}>
            {updatingBusinessName ? 'UPDATING...' : 'UPDATE'}
          </button>
        </div>
      </>}
    </div>
  );
};

export default StaffInfo;
